// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2c-7i","footer":"Form_footer__2N19g"};